import { ComponentProps } from 'react';
import { BaseSidebarItem } from '../common/components/SidebarBase/SidebarNavigation';

export const ExternalSidebarClassNames: ComponentProps<typeof BaseSidebarItem>['classNames'] = {
  icon: 'text-brand-400',
  text: 'text-brand-500',
};
